<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm theo báo cáo khách hàng</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0 overflow-visible"
                outlined
        >

          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" one-line>
              <v-list-item-content class="overflow-visible pa-0">
                <!--          <v-list-item-title class="headline mb-2">-->
                <!--            Tìm Kiếm-->
                <!--          </v-list-item-title>-->

                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider
                            name="Chọn ngày"
                            v-slot="{ errors }"
                            rules="required"
                    >
                      <common-range-picker
                              v-model="selectRange"
                              :aLight="'center'"
                              :clearable="true"
                              :defaultRange="defaultRange"
                              @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>

                  </v-col>

                  <v-col cols="12" md="6">
                    <div class="text-right mt-2">
                      <v-btn
                              class="primary mx-0"
                              @click.prevent="handleSubmit(searchReport)"
                      >
                        <v-icon>mdi-magnify</v-icon>Tìm kiếm
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

              </v-list-item-content>
            </v-list-item>
          </validation-observer>

        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>

import { formatDate } from '@/helpers/utils'
import * as moment from 'moment'

export default {
  props: {
    filterForm: {
      default: () => ({}),
    },
  },
  data () {
    return {
      defaultRange: {
        startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
      },
      selectRange: [{
        startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
      }],
    }
  },
  created() {
  },
  methods: {
    searchReport () {
      this.$emit('click-search', this.filterForm)
    },
    changeDateRange (dateRange) {
      this.filterForm.dateRange = dateRange
      this.selectRange = dateRange
    },
  },
}
</script>
